export const borderRadius = {
  '2xsmall': '4px',
  xsmall: '6px',
  small: '8px',
  base: '12px',
  medium: '16px',
  large: '24px',
  xlarge: '32px',
} as const;

export type BorderRadiusKey = keyof typeof borderRadius;
